angular.module('content.widgets.EventsWidgetService', [
  'global'
])

/**
 * The EventsWidgetService service handles scoring and
 * feedback for the state.contentView type
 *
 * @class EventsWidgetService
 * @constructor
 * @module content.widgets.EventsWidgetService
 */
.factory('EventsWidgetService', [
  '$rootScope',
  'ModelsService',
  'ReportsService',
  function ($rootScope, ModelsService, ReportsService) {
    'use strict';

    var service = {

      content: {
        events: []
      },

      /**
       * Processes the scoring and feedback of
       * state.learningOutcomes item types.
       *
       * Feedback properties that are always returned
       * attempts
       * disabled
       * points
       * correct
       * targetId
       * choiceFeedback
       *
       * Feedback properties that are only returned once max attempts reached or correct answer
       * correctFeedback
       * incorrectFeedback
       * rule
       *
       * @param {string} stateId - ID of the state
       * @param {string} type - The type of event
       * @param {string} decision - Decision Content
       * @param {Array<Object>} selectedIds - IDs of the selected choices
       * @param {boolean} [reset=false] - reset disabled and feedback
       * @param {boolean} [scored=true] - chooses if event should be scored
       * @return {Promise<Object>} Full feedback object resulting from process
       */
      process: function process(stateId, type, decision, selectedIds, reset, scored) {
        var endpoint;
        var e;
        if (reset) {
          service.disabled = [];
          service.feedback = {
            rule: null,
            attempts: {
              max: 0,
              taken: 0
            },
            disabled: [],
            points: {
              earned: 0,
              total: 0
            },
            correct: {
              earned: [],
              total: 0,
              isCorrect: false
            },
            targetId: '',
            correctFeedback: [],
            incorrectFeedback: [],
            choiceFeedback: null
          };
        }

        endpoint = ModelsService.find('endpoints', 'label', 'events');

        e = {
          label: 'event-' + uuid.v1(),
          content: {
            scored: typeof scored === 'boolean' ? scored : true,
            decision: decision,
            end: false,
            type: type,
            stateId: stateId,
            reportId: $rootScope.report.id,
            choices: selectedIds
          }
        };

        return ModelsService
          .create(endpoint, e)
          .then(function (response) {
            service.capture(response);
            return response;
          })
          .catch(function (err) {
            console.log(err);
          });
      },

      /**
       * Stores the given event in the Service.
       *
       * @param {Object} event - event to add
       */
      capture: function capture(event) {
        service.content.events.push(event);
      },

      /**
       * Method formats report data for display.
       *
       * @param {Object} model - model to be formatted
       * @private
       */
      formatReports: function formatReports(model) {
        model.content.timing = {
          start: $rootScope.report.createdAt
        };

        return ReportsService.formatEvents(model);
      }

    };

    return service;
  }
]);
